const benefits = [
  {
    icon: 'ri-database-2-line',
    title: 'Organized Product Database',
    description: 'Find products by category, style and purpose — everything neatly organized in one accessible spreadsheet format.',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Faster Decision Making',
    description: 'Compare products side by side without opening multiple pages. Make informed choices quickly and confidently.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Beginner Friendly',
    description: 'Simple step-by-step guides designed for new users. No technical knowledge required to get started.',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Updated Information',
    description: 'Regularly refreshed content ensures you always have access to the latest products and categories.',
  },
];

export default function WhyUseSection() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-label font-semibold text-accent-700 bg-accent-100/80 rounded-full mb-3">
            Why Choose
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            Why Thousands Of Users Search For VigorBuy Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            Here is what makes the VigorBuy Spreadsheet resource stand out from the crowd.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {benefits.map((item) => (
            <div
              key={item.title}
              className="group p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/50 hover:border-accent-200 transition-all duration-300"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-accent-100/70 mb-4 group-hover:bg-accent-200/70 transition-colors">
                <i className={`${item.icon} text-lg md:text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}